import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { login } from "@/lib/api";
import { Logo } from "@/components/Logo";

function fmtErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      if (data?.token) localStorage.setItem("mv_token", data.token);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      toast.error(fmtErr(err?.response?.data?.detail) || err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-surface flex flex-col">
      <div className="container-mv py-6 flex items-center justify-between">
        <Logo />
        <a href="/" className="inline-flex items-center gap-2 text-sm font-medium text-neutral-700 hover:text-brand-red">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </a>
      </div>
      <div className="flex-1 flex items-center justify-center p-4">
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="w-full max-w-md bg-white border border-neutral-200 rounded-2xl shadow-premium p-8"
        >
          <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">Admin</div>
          <h1 className="mt-2 font-display font-bold text-3xl text-brand-black">Sign in</h1>
          <p className="mt-2 text-sm text-neutral-600">Access booking submissions and manage requests.</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label className="text-xs font-semibold text-neutral-700">Email</Label>
              <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="admin@mavtechtires.ca" className="mt-1.5" />
            </div>
            <div>
              <Label className="text-xs font-semibold text-neutral-700">Password</Label>
              <Input data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="••••••••" className="mt-1.5" />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white px-6 py-3 text-sm font-semibold hover:bg-[#CC0000] active:scale-95 transition-all disabled:opacity-70"
            >
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
